export const QA_NAME_CALENDAR_TASK_MOVE_MODAL = 'calendarTaskMove'

export const QA_NAME_CALENDAR_TASK_MOVE_SUMMARY = 'calendarTaskMoveSummary'

export const QA_NAME_CALENDAR_TASK_MOVE_PREVIOUS_DEADLINE =
  'calendarTaskMovePreviousDeadline'

export const QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD = 'calendarTaskMoveDayLoad'

export const QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD_FAILED =
  'calendarTaskMoveDayLoadFailed'

export const QA_NAME_CALENDAR_TASK_MOVE_PROCESS_NOTICE =
  'calendarTaskMoveProcessNotice'
